import { jsx as e, jsxs as t } from "react/jsx-runtime";
import n from "clsx";
//#region src/components/assets/AssetSvg.tsx
var r = ({ label: r, monochrome: i, frame: a, className: o, children: s, ...c }) => {
	let l = c["aria-label"] ?? (r?.trim() || void 0), u = !!(l || c["aria-labelledby"]);
	return /* @__PURE__ */ t("svg", {
		role: u ? "img" : void 0,
		"aria-hidden": !u || void 0,
		focusable: "false",
		...c,
		"aria-label": l,
		className: [
			"pf-asset pf:inline-block pf:flex-none pf:align-middle pf:max-w-[none]",
			i && n("pf-asset-monochrome pf:text-soft-pearl-900 pf:[&.pf-icon-inherit]:text-inherit", "pf:[&.pf-icon-quiet]:text-soft-pearl-800 pf:[&.pf-icon-strong]:text-soft-pearl-1000", "pf:[&.pf-icon-brand]:text-blue-700 pf:[&.pf-icon-destructive]:text-red-700"),
			a && "pf-asset-frame pf:rounded-full pf:overflow-hidden",
			o
		].filter(Boolean).join(" "),
		children: [s, a === "circle" && /* @__PURE__ */ e("circle", {
			className: "pf-asset-border pf:stroke-soft-pearl-300 pf:pointer-events-none",
			cx: "50%",
			cy: "50%",
			r: "50%",
			fill: "none",
			strokeWidth: "1",
			vectorEffect: "non-scaling-stroke"
		})]
	});
};
//#endregion
export { r as AssetSvg };
